
import {
  computed, defineComponent, reactive, watch,
} from 'vue';
import SelecionarAberturaCaixa from '@/components/Financeiro/ControleCaixas/SelecionarAberturaCaixa.vue';
import UtilitarioData from '@/core/utilitarios/UtilitarioData';
import { useModalBase } from '@/core/composables/ModalBase';
import { useTelaBase } from '@/core/composables/TelaBase';
import Icone from '@/core/components/Icone.vue';
import SelecionarData from '@/core/components/Tela/SelecionarData.vue';
import SelecionarCaixa from '@/components/Cadastros/Financeiro/SelecionarCaixa.vue';
import SelecionarUsuario from '@/components/MeuSistema/Usuarios/SelecionarUsuario.vue';
import { IAberturaCaixa } from '@/models/Entidades/Financeiro/ControleCaixas/AberturaCaixa';
import { IMovimentoFinanceiro } from '@/models/Entidades/Financeiro/MovimentosFinanceiros/IMovimentoFinanceiro';
import { ICaixa } from '@/models/Entidades/Cadastros/Financeiro/ICaixa';
import { IParametrosConsulta } from '@/core/models/Consulta/IParametrosConsulta';
import ServicoControleCaixas from '@/servicos/Financeiro/ServicoControleCaixas';
import ServicoCaixa from '@/servicos/Cadastros/Financeiro/ServicoCaixa';
import AberturaCaixaModal from './AberturaCaixaModal.vue';

export default defineComponent({
  name: 'SelecionarAberturaCaixaModal',
  props: {
    visivel: {
      type: Boolean,
    },
    empresa: {
      type: Number,
      default: 0,
    },
    aberturaCaixa: {
      type: Object as () => IAberturaCaixa,
      required: true,
    },
  },
  components: {
    SelecionarData,
    SelecionarCaixa,
    SelecionarUsuario,
    SelecionarAberturaCaixa,
    AberturaCaixaModal,
    Icone,
  },
  emits: ['update:aberturaCaixa', 'update:visivel', 'confirmar'],
  setup(props, { emit }) {
    const { modalBase } = useModalBase(props, emit);
    const { telaBase, apresentarMensagemAlerta } = useTelaBase();
    const servicoControleCaixas = new ServicoControleCaixas();
    const servicoCaixa = new ServicoCaixa();
    servicoCaixa.requisicaoSistema();
    const state = reactive({
      codigoCaixa: 0,
      codigoUsuario: 0,
      data: UtilitarioData.obterDataAtual(),
      codigoAberturaCaixa: 0,
      codigoMovimentacao: 0,
      motivoReabertura: '',
      usuarios: [] as number[],
      caixa: {} as ICaixa,
      aberturaCaixa: {} as IAberturaCaixa,
      parametrosConsulta: {} as IParametrosConsulta,
      movimentos: [] as IMovimentoFinanceiro[],
      exibirAberturaCaixa: false,
      apresentarAberturaCaixa: false,
    });
    const computedAberturaCaixa = computed({
      get: () => props.aberturaCaixa,
      set: (val: IAberturaCaixa) => {
        emit('update:aberturaCaixa', val);
      },
    });

    async function buscarAberturaCaixa() {
      if (state.codigoAberturaCaixa !== undefined && state.codigoAberturaCaixa > 0) {
        state.aberturaCaixa = await servicoControleCaixas.obterAberturaCaixa(state.codigoAberturaCaixa, props.empresa);
        computedAberturaCaixa.value = state.aberturaCaixa;
      }
    }

    function limparAberturaCaixa() {
      state.codigoAberturaCaixa = 0;
      state.aberturaCaixa = {} as IAberturaCaixa;
      state.codigoMovimentacao = 0;
      state.movimentos = [] as IMovimentoFinanceiro[];
      state.apresentarAberturaCaixa = false;
    }

    async function buscarOperadores() {
      limparAberturaCaixa();
      if (state.codigoCaixa > 0 && state.codigoCaixa !== undefined && state.data !== '' && state.data !== undefined) {
        state.codigoUsuario = 0;
        state.usuarios = await servicoControleCaixas.obterOperadoresCaixa(state.codigoCaixa, props.empresa, state.data);
      }
    }

    async function buscarCaixa() {
      if (state.codigoCaixa > 0 && state.codigoCaixa !== undefined) {
        state.caixa = await servicoCaixa.obter(state.codigoCaixa, props.empresa);
        buscarOperadores();
      }
    }

    function abrirCaixa() {
      state.exibirAberturaCaixa = true;
    }

    function cancelar() {
      modalBase.computedVisivel = false;
    }

    function confirmar() {
      if (state.codigoCaixa === 0) {
        apresentarMensagemAlerta('É necessário selecionar um caixa');
        return;
      }
      if (state.codigoUsuario === 0) {
        apresentarMensagemAlerta('É necessário selecionar um operador');
        return;
      }
      if (state.codigoAberturaCaixa === 0) {
        apresentarMensagemAlerta('É necessário selecionar a abertura do caixa');
        return;
      }
      emit('confirmar');
      modalBase.computedVisivel = false;
    }

    watch(async () => modalBase.computedVisivel, async () => {
      if (modalBase.computedVisivel) {
        telaBase.carregando = true;
        telaBase.carregando = false;
      }
    });

    return {
      props,
      state,
      modalBase,
      telaBase,
      buscarCaixa,
      buscarOperadores,
      limparAberturaCaixa,
      buscarAberturaCaixa,
      abrirCaixa,
      cancelar,
      confirmar,
    };
  },
});
